import { Card, CardContent } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { Label } from "@/components/ui/label"
import { Check } from "lucide-react"
import type { SearchParams } from "@/types/job-search"
import EditFiltersOnResults from "./search/EditFiltersOnSearchResults"
import type { GetSearchQueries200 } from "openapi/api/model"
import { buildFilterSummary } from "@/lib/search-filter-model"
//import { configSpring } from "recharts/types/animation/easing"

interface JobSearchContextProps {
  searchParams: SearchParams
  searchConfig?: GetSearchQueries200
  onSearchUpdated: (searchHash: string) => void
}

export function JobSearchContext({ searchParams, searchConfig, onSearchUpdated }: JobSearchContextProps) {
  const { query, filters } = searchParams
  const summaryItems = buildFilterSummary(filters)

  if (!query && summaryItems.length === 0) {
    return null
  }

  return (
    <Card>
      <CardContent className="p-4">
        <div className="space-y-3">
          {query && (
            <div>
              <Label className="text-sm font-medium">Original Query:</Label>
              <p className="text-sm text-muted-foreground mt-1">{query}</p>
            </div>
          )}
          {summaryItems.length > 0 && (
            <div>
              <Label className="text-sm font-medium">Extracted Entities:</Label>
              <div className="flex flex-wrap gap-2 mt-2">
                {summaryItems.map((item) => (
                  <Badge key={item.id} variant="secondary" className="bg-green-50 text-green-700 border-green-200">
                    <Check className="h-3 w-3 mr-1" />
                    {item.label}: {item.value}
                  </Badge>
                ))}
              </div>
            </div>
          )}
          
            <EditFiltersOnResults searchConfig={searchConfig} onSearchUpdated={onSearchUpdated} />
        </div>
      </CardContent>
    </Card>
  )
}
